// extracted by mini-css-extract-plugin
export default {"dropdownsContainer":"ItemFAQ_dropdownsContainer__g+spx"};